














































































































































import {Component, Watch} from "vue-property-decorator";
import ViewList from "../List.vue";
import {Getter} from "vuex-class";
import OwnerAttributeDefinitionRepository from "@/repositories/OwnerAttributeDefinitionRepository";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import _ from "lodash";
import MasterOwnerRepository from "@/repositories/MasterOwnerRepository";
import moment from "moment";

const components = {
    SelectOwner
};

interface OwnerAttributeDefinition {
    uuid: string;
    attribute: {
        uuid: string;
        label: string;
        type: string;
    };
    rank: number;
    module: string;
}

@Component({ components })
export default class OwnerManager extends ViewList {
    @Getter("getUserDepartment") public userDepartment!: string;
    @Getter("getMasterOwners") public allOwners!: any[];
    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;

    private attributesDefinition: OwnerAttributeDefinition[] = [];
    private ownerUuidEdit: string | null = null;
    private currentOwnerEdit: any = null;
    private loading = false;
    private currentValueZoneSelected: any[] = [];
    private newValueZoneSelected: any[] = [];
    private newAttributeValue: string = "";
    private currentAttributeDefinition: string = "";
    private newAttributeStartDate: string = "";

    public mounted(): void {
        OwnerAttributeDefinitionRepository.get().then((data) => {
            this.attributesDefinition = data as OwnerAttributeDefinition[];
            if (this.ownerUuidEdit) {
                this.updateSelectedOwner(this.ownerUuidEdit);
            }
        });
    }

    @Watch("ownerUuid") private changeOwner() {
        this.ownerUuidEdit = null;
    }

    private updateSelectedOwner(ownerUuidSelected: string): void {
        this.loading = true;
        this.ownerUuidEdit = ownerUuidSelected;
        this.currentOwnerEdit = null;

        if (0 === this.attributesDefinition.length) {
            return;
        }

        const params = {
            filters: {
                ownerUuid: ownerUuidSelected,
                orderAttributeEndDate: true,
            },
            fields: [
                "uuid",
                "attributes.attribute.uuid",
                "attributes.value",
                "attributes.uuid",
                "attributes.startDate",
                "attributes.endDate",
                "zones.iris",
                "zones.type",
                "zones.description",
            ]
        };

        MasterOwnerRepository.get(params).then((data) => {
            this.currentOwnerEdit = data[0];

            _.forEach(this.attributesDefinition, (attributeDefinition) => {
                if (!_.find(this.currentOwnerEdit.attributes, (attribute) => {
                    return attribute.attribute.uuid === _.get(attributeDefinition, "attribute.uuid", "");
                })) {
                    this.currentOwnerEdit.attributes.push(
                        {value: "", attribute: { uuid: _.get(attributeDefinition, "attribute.uuid", "")}}
                    );
                }
            });

            this.ownerUuidEdit = _.get(this.currentOwnerEdit, "uuid", null);
            this.loading = false;
            this.resetNewAttributeFields();
        });
    }

    private updateAttributeZone(value: string[], attributeUuid: string): void {
        const currentAttribute = _.find(this.currentOwnerEdit.attributes, (attribute) => {
            return attribute.attribute.uuid === attributeUuid;
        });
        _.set(currentAttribute, "value", _.join(value, ","));
    }

    private updateOwnerAttributes(): void {
        _.remove(this.currentOwnerEdit.attributes, (attribute: any, idx) => {
            return _.isEmpty(attribute.value);
        });

        MasterOwnerRepository.save(this.currentOwnerEdit).then((data) => {
            this.$message({
                type: "success",
                message: _.invoke(this.$options.filters, "trans", "ownerAttributeUpdated"),
            });
            this.updateSelectedOwner(this.currentOwnerEdit.uuid);
        }).catch((error) => {
            this.$message({
                type: "error",
                message: _.invoke(this.$options.filters, "trans", "errorOwnerAttributeSaving"),
            });
            this.updateSelectedOwner(this.currentOwnerEdit.uuid);
        });
    }

    private addNewAttributeValue(
        newAttributeValue: string,
        newAttributeStartDate: string,
        currentAttributeDefinition: string
    ): void {
        const attributeToAdd = {
            value: newAttributeValue,
            attribute: {
                uuid: currentAttributeDefinition,
            },
            startDate: newAttributeStartDate,
            endDate: null,
        };
        const attributeToExpire = _.find(this.currentOwnerEdit.attributes, (attribute) => {
            return attribute.attribute.uuid === currentAttributeDefinition;
        });

        if (attributeToExpire &&
            newAttributeStartDate <= _.get(attributeToExpire, "startDate", "")
        ) {
            this.$message({
                message: _.invoke(this.$options.filters, "trans", "errorNewStartDateBeforeOrEqualOldStartDate"),
                type: "error"
            });
            return;
        }

        _.set(attributeToExpire, "endDate", moment(newAttributeStartDate).subtract(1, "s"));
        this.currentOwnerEdit.attributes.push(attributeToAdd);
        this.updateOwnerAttributes();
        this.resetNewAttributeFields();
    }

    private isAttributeZone(currentAttributeDefinition: string): boolean {
        const currentAttribute = _.find(this.attributesDefinition, (attribute: OwnerAttributeDefinition) => {
           return currentAttributeDefinition === attribute.attribute.uuid;
        });
        if (!currentAttribute) {
            return false;
        }
        return "zone" === currentAttribute.attribute.type;
    }

    private addAttributeZone(value: string[]) {
        this.newAttributeValue = _.join(value, ",");
    }

    private resetNewAttributeFields(): void {
        this.newAttributeValue = "";
        this.newAttributeStartDate = "";
        this.currentAttributeDefinition = "";
        this.newValueZoneSelected = [];
    }
}
